<template>
  <inertia-link v-if="link" :href="href" class="flex flex-col justify-between h-full relative">
    <slot></slot>
  </inertia-link>
  <p v-if="!link" class="flex flex-col justify-between h-full relative">
    <slot></slot>
  </p>
</template>

<script>
export default {
  name: "ConditionalLink",
  props: ['link', 'href']
}
</script>
